export default "__VITE_ASSET__Ceggdy$y__"